/**
 * TokenUserEvents
 * Registry of events for the Token pages
 */
export enum TokenUserEvents {
    TableAssetLinkClick = "Token Table - Click Asset Individual Page Link",
    TableAssetClassLinkClick = "Token Table - Click Asset Class Page Link",
    TableProtocolLinkClick = "Token Table - Click Protocol Page Link",
    TableNetworkLinkClick = "Token Table - Click Network Page Link",
    OpenConfidentialNetworkContactModal = "Tokens - Open Confidential Network Contact Modal",
}
